import script from "./ModalLoginObrigatorio.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalLoginObrigatorio.vue?vue&type=script&setup=true&lang=js"

import "./ModalLoginObrigatorio.vue?vue&type=style&index=0&id=793e2830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-793e2830"]])

export default __exports__